import script from "./SummaryContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryContainer.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryContainer.vue?vue&type=style&index=0&id=1039ae3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1039ae3a"]])

export default __exports__